import { bulkUploadDataValidationInterfaceInstance } from 'Interfaces/FactsInterfaces/tmsInterfaces';
import classes from './DataValidationComponent.module.scss';
import { Button } from 'primereact/button';
import useDataValidationComponent from './useDataValidatonComponent';
import DeleteIcon from 'assets/icons/deleteIcon.svg';
import SuccessIcon from 'assets/icons/successIcon.svg';
import FailureIcon from 'assets/icons/failureIcon.svg';

import { observer } from 'mobx-react';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import TmsStrategiesResolveErrorsModal from './components/TmsStrategiesResolveErrorModal/TmsStrategiesResolveErrorsModal';

const DatavalidationComponent = ({
  data,
  successCallBack,
}: // view = "view",
{
  data: bulkUploadDataValidationInterfaceInstance[];
  successCallBack: () => void;
  // view?: "view" | "edit";
}) => {
  const {
    bulkUpdateData,
    view,
    isBulkUpdating,
    checkIfThereAreErrors,
    handleVerify,
    handleRowDeleteButtonClick,
    getErrorDescription,
    isAnimationRunning,
    bulkUpdateResponse,
    getMaxWidthForProgressBar,
    cotOptions,
    strategyOptions,
    allStrategyOptions,
    inputOperations,
    checkIfVerifyDataButtonIsDiabled,
    storedStrategiesRowIndex,
    handleCloseStoredStrategiesModal,
    handleClickStoredStrategies,
  } = useDataValidationComponent({ data, successCallBack });
  return (
    <div className={classes.DataValidationComponentcontainer}>
      {!isAnimationRunning ? (
        <>
          <div className={classes.tableWrapper}>
            <table className={classes.dataTable} style={{ maxHeight: '60vh !important' }}>
              <thead>
                <tr>
                  <th>GFC</th>
                  <th>COT</th>
                  <th>TMS</th>
                  <th>Selling Category</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>TMS Strategy</th>
                  {checkIfThereAreErrors() && (
                    <th className={classes.errorsTh}>Stored Strategies</th>
                  )}
                  {checkIfThereAreErrors() && <th className={classes.resolveErrors}>Errors</th>}
                </tr>
              </thead>
              <tbody className="bulkUpdateTable" style={{ maxHeight: '60vh !important' }}>
                {view === 'view' ? (
                  <>
                    {bulkUpdateData.map((data, index) => {
                      return (
                        <tr key={'dataValidation' + index}>
                          <td>{data.GFC}</td>
                          <td>{data.COT}</td>
                          <td>{data.TargetMarketShare}</td>
                          <td>{data.SellingCategory}</td>
                          <td style={{ minWidth: '10rem' }}>{data.StartDate}</td>
                          <td style={{ minWidth: '10rem' }}>{data.EndDate}</td>
                          <td style={{ minWidth: '10rem' }}>{data.TMSStrategy}</td>
                          {/* {checkIfThereAreErrors() && (
                        <td className={classes.errorsTd}></td>
                      )} */}
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {bulkUpdateData.map((data, index) => {
                      return (
                        <tr key={'dataValidation' + index}>
                          <td>
                            <InputText
                              required
                              type="numeric"
                              value={inputOperations.gfc.value(index).toString()}
                              onChange={e => inputOperations.gfc.onChange(index, e.target.value)}
                              style={{
                                padding: '0.3rem 0.5rem',
                              }}
                            />
                          </td>
                          <td>
                            <Dropdown
                              value={inputOperations.cot.value(index)}
                              onChange={e => {
                                inputOperations.cot.onChange(index, e.target.value.name);
                              }}
                              options={cotOptions}
                              optionLabel="name"
                              placeholder="Select COT"
                              panelStyle={{
                                padding: '0.0rem 0.5rem',
                                color: 'red',
                              }}
                              style={{
                                width: '9rem',
                                maxWidth: '9rem',
                                padding: '0.0rem 0.5rem',
                                maxHeight: '2rem',
                              }}
                            />
                          </td>
                          <td>
                            <InputText
                              required
                              type="numeric"
                              value={inputOperations.tms.value(index).toString()}
                              onChange={e => inputOperations.tms.onChange(index, e.target.value)}
                              style={{
                                padding: '0.3rem 0.5rem',
                              }}
                            />
                          </td>
                          <td>
                            <Dropdown
                              value={inputOperations.sellingCategory.value(index)}
                              onChange={e => {
                                inputOperations.sellingCategory.onChange(
                                  index,
                                  e.target.value.name
                                );
                              }}
                              options={strategyOptions}
                              optionLabel="name"
                              placeholder="Select Selling Category"
                              style={{
                                width: '9rem',
                                maxWidth: '9rem',
                                padding: '0.0rem 0.5rem',
                                maxHeight: '2rem',
                              }}
                            />
                          </td>
                          <td>
                            <Calendar
                              view="month"
                              dateFormat="mm/yy"
                              className={classes.dateInput}
                              minDate={inputOperations.startDate.minDate()}
                              onChange={e =>
                                inputOperations.startDate.onChange(e.target.value, index)
                              }
                              value={inputOperations.startDate.value(index)}
                              // style={{ width: "6rem", maxWidth: "10rem" }}
                              style={{
                                width: '5rem',
                                maxWidth: '5rem',
                                maxHeight: '3rem',
                                margin: 'auto 0.5rem',
                              }}
                            />
                          </td>
                          <td>
                            <Calendar
                              view="month"
                              dateFormat="mm/yy"
                              className={classes.dateInput}
                              minDate={inputOperations.endDate.minDate(index)}
                              onChange={e =>
                                inputOperations.endDate.onChange(e.target.value, index)
                              }
                              value={inputOperations.endDate.value(index)}
                              style={{
                                width: '5rem',
                                maxWidth: '5rem',
                                maxHeight: '3rem',
                                margin: 'auto 0.5rem',
                              }}
                            />
                          </td>
                          <td>
                            <Dropdown
                              value={inputOperations.tmsStrategy.value(index)}
                              onChange={e => {
                                inputOperations.tmsStrategy.onChange(index, e.target.value.name);
                              }}
                              options={allStrategyOptions}
                              optionLabel="name"
                              placeholder="Select TMS Strategy"
                              style={{
                                width: '9rem',
                                maxWidth: '9rem',
                                padding: '0.0rem 0.5rem',
                                maxHeight: '2rem',
                              }}
                            />
                          </td>
                          <td onClick={() => handleClickStoredStrategies(index)}>
                            <div className={classes.tmsStoredStrategies}>Stored Strategies</div>
                          </td>
                          <td>
                            <div className={classes.errorDescription}>
                              {getErrorDescription(index)}
                            </div>
                          </td>
                          {checkIfThereAreErrors() && (
                            <td>
                              <img
                                className={classes.deleteIcon}
                                src={DeleteIcon}
                                alt="Delete"
                                onClick={() => handleRowDeleteButtonClick(index)}
                              />
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </>
                )}
              </tbody>
            </table>
          </div>
          <Button
            className={classes.verifyButton}
            onClick={handleVerify}
            loading={isBulkUpdating}
            disabled={checkIfVerifyDataButtonIsDiabled()}
          >
            Verify
          </Button>
        </>
      ) : (
        <div className={classes.animationContainer}>
          {bulkUpdateResponse !== 'Success' && (
            <table>
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <img
                      src={
                        bulkUpdateResponse?.isfileStructureCOTSellingCategoryTmsStrategyValidity
                          .invalid
                          ? FailureIcon
                          : SuccessIcon
                      }
                      alt=""
                      style={{ animationDelay: '1s' }}
                    />
                  </td>
                  <td>Validating file structure, GFC, COT, Selling Category, TMS Strategy </td>
                </tr>
                <tr>
                  <td>
                    {bulkUpdateResponse?.isfileStructureCOTSellingCategoryTmsStrategyValidity
                      .invalid == false && (
                      <img
                        src={
                          bulkUpdateResponse?.isFileDatesOverlapping.invalid
                            ? FailureIcon
                            : SuccessIcon
                        }
                        alt=""
                        style={{ animationDelay: '3s' }}
                      />
                    )}
                  </td>
                  <td>Checking file date ranges overlaps</td>
                </tr>
                <tr>
                  <td>
                    {bulkUpdateResponse?.isfileStructureCOTSellingCategoryTmsStrategyValidity
                      .invalid == false &&
                      bulkUpdateResponse?.isFileDatesOverlapping.invalid == false && (
                        <img
                          src={
                            bulkUpdateResponse?.isStoredStrategiesDatesOverlapping.invalid
                              ? FailureIcon
                              : SuccessIcon
                          }
                          alt=""
                          style={{ animationDelay: '5s' }}
                        />
                      )}
                  </td>
                  <td>Checking date range overlaps with stored tms strategies</td>
                </tr>
              </tbody>
            </table>
          )}
          <div className={classes.progressBar}>
            <div
              className={classes.percentageBar}
              style={{ maxWidth: getMaxWidthForProgressBar() }}
            ></div>
          </div>
        </div>
      )}

      {storedStrategiesRowIndex != null && (
        <TmsStrategiesResolveErrorsModal
          gfc={bulkUpdateData[storedStrategiesRowIndex].GFC}
          cot={bulkUpdateData[storedStrategiesRowIndex].COT}
          sellingCategory={bulkUpdateData[storedStrategiesRowIndex].SellingCategory}
          visiblility={storedStrategiesRowIndex === null ? false : true}
          toggleVisibility={handleCloseStoredStrategiesModal}
        />
      )}
    </div>
  );
};

export default observer(DatavalidationComponent);
